import TaskState from '@src/editor-helpers/TaskState'
import EditorStateOps from './EditorStateOps'
import { EditorState } from 'draft-js'

export default (editorState: EditorState) => {
  const taskState = TaskState.fromEditorState(editorState)
  const focusBlock = EditorStateOps.getFocusBlock(editorState)
  const focusTask = TaskState.getTaskByKey(taskState, focusBlock.get('key'))
  return focusTask.conspectKeys[0]
}



// WEBPACK FOOTER //
// ./src/editor-helpers/EditorStateOps/getFocusKeyOfFirstConspect.ts